var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGarden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 49.731,
    viewBox: "0 0 55 49.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(-4 -7.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M10.949,12.158C8.626,13.438,4,16.674,4,20V34H8V28a3,3,0,0,1,6,0v6h4V20C18,17.634,13.949,14.141,10.949,12.158Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M11,27a1,1,0,0,0-1,1V39h2V28A1,1,0,0,0,11,27Zm2,24.379V41H9V51.379a1,1,0,0,1-.247.659A2.955,2.955,0,0,0,8,54a3,3,0,0,0,6,0,2.955,2.955,0,0,0-.753-1.962A1,1,0,0,1,13,51.379ZM12,55H10V53h2ZM53,22a1,1,0,0,0-1,1V39h2V23A1,1,0,0,0,53,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M53,7.269C51.376,8.6,47,12.626,47,17.5v7.738a25.145,25.145,0,0,0,3,.567V23a3,3,0,0,1,6,0v2.814a23.758,23.758,0,0,0,3-.571V17.5C59,12.656,54.606,8.593,53,7.269Zm2,44.11V41H51V51.379a1,1,0,0,1-.247.659A2.955,2.955,0,0,0,50,54a3,3,0,0,0,6,0,2.955,2.955,0,0,0-.753-1.962A1,1,0,0,1,55,51.379ZM54,55H52V53h2ZM32,30a1,1,0,0,0-1,1v8h2V31A1,1,0,0,0,32,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M38,16v9a1,1,0,0,1-1,1H34a1,1,0,0,1-1-1V13a1,1,0,0,0-2,0V25a1,1,0,0,1-1,1H27a1,1,0,0,1-1-1V16a3.006,3.006,0,0,0-2-2.829V29a5.006,5.006,0,0,0,5,5V31a3,3,0,0,1,6,0v3a5.006,5.006,0,0,0,5-5V13.171A3.006,3.006,0,0,0,38,16ZM34,51.379V41H30V51.379a1,1,0,0,1-.247.659A2.955,2.955,0,0,0,29,54a3,3,0,0,0,6,0,2.955,2.955,0,0,0-.753-1.962A1,1,0,0,1,34,51.379ZM33,55H31V53h2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.2c01bbb0ea4f940a1dc26f59ff9a9c2e.svg";
export { ForwardRef as ReactComponent };